import getSymbolFromCurrency from "currency-symbol-map";

import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { setAudienceCurrencyValue } from "@src/store/slices/audiences";
import { setExperienceCurrency } from "@src/store/slices/experiences";

/**
 * Targets the experience to buyers shopping in `code`, the way the manual
 * shipping-progress-bar currency picker does — both the manual settings UI
 * and Ellie's `setShippingProgressBarBlock` tool go through this, so the two
 * can't drift. `setAudienceCurrencyValue` also re-triggers
 * `setupAudiencesListener`'s post-purchase re-default, so a block created
 * while a post-purchase upsell is present still ends up locked to the store
 * currency, same as the manual flow.
 */
export const setShippingProgressBarCurrency = createAsyncThunk<
  void,
  { code: string }
>("checkoutBlocks/setShippingProgressBarCurrency", ({ code }, { dispatch }) => {
  const symbol = getSymbolFromCurrency(code) || "$";
  dispatch(setExperienceCurrency({ code, symbol }));
  dispatch(setAudienceCurrencyValue({ value: code, isMultiCurrency: true }));
});
